import { SUPPORT_STATUS_COLORS, supportStatusLabel } from "../utils";

import { StatusBadge } from "../style";

const SupportStatusBadge = ({ status }) => {
  const colors = SUPPORT_STATUS_COLORS[status] || {};

  return (
    <StatusBadge $color={colors.color} $background={colors.background}>
      {supportStatusLabel(status)}
    </StatusBadge>
  );
};

export default SupportStatusBadge;
